export default "__VITE_PUBLIC_ASSET__9ec9bd02__"